type Config = {
  apiKey: string;
};

export const config: Config = {
  apiKey: 'AIzaSyAZKMoXSNlcFPxTCT3nVY5GsOBItH_OHTg',
};
